import { is_franchise_accountant, is_franchise_admin, is_franchise_manager, is_superuser } from "../../Functionalities/Config";

export const canSettle = () => Boolean(is_superuser || is_franchise_admin || is_franchise_manager || is_franchise_accountant);
